import { render, staticRenderFns } from "./AdminRoom.vue?vue&type=template&id=6a432bf8&scoped=true"
import script from "./AdminRoom.vue?vue&type=script&lang=js"
export * from "./AdminRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a432bf8",
  null
  
)

export default component.exports